<template>
    <div>
        <div class="table">
            <b-table foot-clone :fields="fields" :items="items">
                <template #cell(name)="data">
                    <div style="display: flex">
                        <div class="img-column">
                            <img v-if="data.item.imageUrl" class="column-img" :src="data.item.imageUrl" @error="$event.target.src='https://i.ibb.co/S5zDRCH/logo.png'" alt='Slika nije pronadjena'/>
                        </div>
                        <div style="display: flex; align-items: center">
                            <div>
                                <div>{{data.item.name}}</div>
                                <div v-if="data.item.selectedSmell" class="smell-info">
                                    <small class="text-muted">Miris: {{data.item.selectedSmell.name}}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>

                <template #cell(amountOrdered)="data">
                    <div v-if="data.value > 0" class="centered-column">
                        <button @click="decrement(data.item.id)" class="amount-button" type="button"> -</button>
                        <p>{{data.value}}</p>
                        <button @click="increment(data.item.id)" class="amount-button" type="button" :disabled="data.item.amountOrdered >= data.item.amountInStock"> +</button>
                    </div>
                </template>

                <template #cell(price)="data">
                    <div class="centered-column">
                        <p>{{data.value}}</p>
                    </div>
                </template>

                <template #cell(totalPrice)="data">
                    <div class="centered-column">
                        <p>{{data.value}}</p>
                    </div>
                </template>

                <template #cell(delete)="data">
                    <div v-if="data.value" class="close-column">
                        <button @click="remove(data.item.id)" class="amount-button" type="button"> x </button>
                    </div>
                </template>

                <template #foot()>
                    <p></p>
                </template>

                <template #foot(totalPrice)>
                    <div class="footer">
                        <p>Ukupno: {{totalPrice}} RSD</p>
                    </div>
                </template>
                <template #table-caption>*Za porudžbine lakse od 500g cena poštarine je 450 RSD, a za porudžbine teže od 500g cena poštarine je 500 RSD.</template>
            </b-table>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: 'CartItemTable',
        data() {
            return {
                fields: [
                    {
                        key: 'name',
                        label: 'Naziv',
                        thStyle: {
                            width: '35%',
                            background: '#fff'
                        },
                        tdClass: 'align-middle'
                    },
                    {
                        key: 'amountOrdered',
                        label: 'Količina',
                        thStyle: {
                            width: '20%',
                            textAlign: 'center',
                            background: '#fff'
                        },
                        tdClass: 'align-middle'
                    },
                    {
                        key: 'price',
                        label: 'Cena',
                        thStyle: {
                            width: '20%',
                            textAlign: 'center',
                            background: '#fff'
                        },
                        tdClass: 'align-middle'
                    },
                    {
                        key: 'totalPrice',
                        label: 'Ukupna Cena',
                        thStyle: {
                            width: '20%',
                            textAlign: 'center',
                            background: '#fff'
                        },
                        tdClass: 'align-middle'
                    },
                    {
                        key: 'delete',
                        label: '',
                        thStyle: {
                            width: '5%',
                            background: '#fff'
                        },
                        tdClass: 'align-middle'
                    }
                ]
            }
        },
        computed: {
            ...mapGetters([
                'getCartItems',
                'getTotalPrice',
                'getTotalPriceWithShipping',
                'getShippingCost'
            ]),

            items: {
                get() {
                    const items =  this.getCartItems.map(item => {
                        return {
                            id: item.id,
                            imageUrl: item.imageUrl,
                            name: item.name,
                            price: (item.price - (item.price * item.discount / 100)) + ' RSD',
                            amountOrdered: item.amountOrdered,
                            totalPrice: (item.price - (item.price * item.discount / 100)) * item.amountOrdered + ' RSD',
                            amountInStock: item.amountInStock,
                            selectedSmell: item.selectedSmell,
                            delete: true
                        }
                    })
                    items.push({
                        id: 'shipping',
                        name: 'Poštarina',
                        amountOrdered: -1,
                        totalPrice: this.getShippingCost + ' RSD'
                    })
                    return items
                }
            },
            totalPrice: {
                get() {
                    return this.getTotalPrice
                }
            }

                // totalPriceWithShipping: {
                //     get() {
                //         return this.getTotalPriceWithShipping
                //     }
                // }
        },
        methods: {
            ...mapActions([
                'incrementAmountOrdered',
                'decrementAmountOrdered',
                'removeCartItem'
            ]),

            increment(id) {
                this.incrementAmountOrdered(id)
            },

            decrement(id) {
                this.decrementAmountOrdered(id)
            },

            remove(id) {
                this.removeCartItem(id)
            }
        }
    }
</script>

<style scoped>
    .close-column {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .centered-column {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .amount-button {
        border: none;
        width: 40px;
        margin: 0 10px;
        font-weight: bold;
        background: transparent;
    }

    .amount-button:hover:enabled {
        color: #6f5193;
    }

    .footer {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .img-column {
        display: table-cell;
    }

    img {
        width: 100px;
        height: 100px;
        margin-right: 10px;
    }

    p {
        margin: 0;
    }

    .smell-info {
        margin-top: 2px;
    }

    .text-muted {
        color: #6c757d !important;
    }
</style>